import React from 'react';
import { Line } from 'rc-progress';

function ProgressBar({ percent }) {
  return (
    <div className="progress-bar">
      <h5 className="heading-5">{percent}%</h5>
      <Line
        percent={percent}
        strokeWidth={1}
        trailWidth={0.75}
        strokeColor="#c51f5d"
        trailColor="#3b444b"
        strokeLinecap="square"
      />
    </div>
  );
}

export default ProgressBar;
